import { Controller, Toolbar } from '@tencent/workbench';
import { ColumnsFeature } from './columns-feature';
import { TOOLBAR_ITEMS, config } from './config';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ColumnsController {
    constructor(private readonly feature: ColumnsFeature) {}

    @Toolbar(config.id, 'dropdownContent')
    public showContent() {
        tdw({
            ...this.feature.getBaseTwdReportConfig(),
            action: TDWActionType.TOOLBAR_COLUMNS_CLICK,
        });
        return this.feature.showContent(true);
    }
}
